import React from 'react';
import PropTypes from 'prop-types';

// @ts-ignore
import CustomFieldTitle from "../form-title";
// @ts-ignore
import CustomFieldActions from "../form-actions";
import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
// @ts-ignore
import CustomFieldName from "../form-name";
// @ts-ignore
import CustomFieldAccess from "../form-access";
import CustomField_FromRowScope from "../form-scope";


type Props = {
    parent      : {
        form        : any
        props       : any
    },

    children    : any
}

export default function CustomFieldRightPanel(props: Props) {

    const showScope = !props.parent.props.ignoreScope;

    return (
        <div className="iv-cf-form">
            <VScroll className="iv-cf-scroll">
                <CustomFieldTitle customField={props.parent.props.customField}/>

                <div className="iv-content with-left-panel">
                    <div className="p-l-30">
                        <div className="ui5-form size-30-70">
                            <div className="f-tbl">
                                <CustomFieldName form={props.parent.form}/>
                                <CustomFieldAccess form={props.parent.form}/>
                                {showScope && <CustomField_FromRowScope form={props.parent.form} mandatoryScope={props.parent.props.mandatoryScope}/> }

                                {props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </VScroll>

            <CustomFieldActions form={props.parent.form}/>
        </div>
    );
}

// CustomFieldRightPanel.propTypes = {
//     parent: PropTypes.shape({
//         form: PropTypes.object,
//         props: PropTypes.object,
//     })
// }
